import { Issue } from './Issue';

export interface AiProgressMessage {
  systemMessage?: string;
  userMessage?: string;
  statusCode: number;
  code: AiProgressMessageCode;
  userId: string;
  propertyId?: string;
  combinedETag: string;
  end: boolean;
  issueCount?: IssueCount | undefined;
  propertyAddress?: string | undefined;
  streamingIssue?: Issue | undefined;
  additionalPayload?: Record<string, any> | undefined;
  // Address-mismatch payload fields. SnsClientWrapper.sendNotification spreads
  // additionalPayload into the top level of the SNS payload, so these arrive
  // as top-level keys — not nested inside `additionalPayload`.
  documentId?: string;
  documentRecordId?: string;
  documentName?: string;
  extractedAddress?: string | null;
  addressConfidence?: number;
  confidenceThreshold?: number;
  reason?: string;
}

export enum AiProgressMessageCode {
  AI_JOB_STARTED = 'bedrock-job-started',
  AI_JOB_FINISHED = 'bedrock-job-finished',
  AI_JOB_CONTENT_UPDATED = 'bedrock-job-content-updated',
  DOCUMENT_ADDRESS_MISMATCH = 'document-address-mismatch',
  DUPLICATE_FOUND = 'duplicate-found',
  DUPLICATE_NOT_FOUND = 'duplicate-not-found',
  DYNAMODB_SAVED = 'dynamodb-saved',
  GENERIC_INTERNAL_ERROR = 'generic-internal-error',
  GENERIC_MISSING_ATTRIBUTES = 'generic-missing-attributes',
  TEXTRACT_JOB_STARTED = 'textract-job-started',
  TEXTRACT_JOB_IN_PROGRESS = 'textract-job-in-progress',
  TEXTRACT_JOB_FINISHED = 'textract-job-finished',
  PULSEAI_JOB_STARTED = 'pulseai-job-started',
  // Sent by documentProcessingFinalizerLambda when a Pulse-dependent step
  // exhausted its retry budget (UploadBatchTerminalStatus.Incomplete). No
  // dedicated UI branch for this code — it arrives with end: true and a
  // non-2xx statusCode, so the existing `isError && end` handling in
  // UploaderProvider stops the "processing" spinner instead of hanging on
  // it indefinitely. The document is preserved and retryable from the
  // admin Properties tab, not deleted like a genuine failure.
  PROCESSING_INCOMPLETE = 'processing-incomplete',
}

export interface AddressMismatchPayload {
  documentId: string;
  documentRecordId?: string;
  documentName?: string;
  propertyId: string;
  extractedAddress: string | null;
  propertyAddress: string;
  addressConfidence: number;
  confidenceThreshold: number;
  reason: string;
}

export interface IssueCount {
  critical: number;
  urgent: number;
  moderate: number;
  low: number;
  monitor: number;
}
